import { Button, Modal } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import "./ReuseSubmitDialog.css";

interface ReuseSubmitDialogProps {
    active: boolean;
    submitDocuments: () => void;
    closeModal: () => void;
    documentCountFunction: () => number;
}

export const ReuseSubmitDialog = ({
    active,
    submitDocuments,
    closeModal,
    documentCountFunction
}: ReuseSubmitDialogProps) => {
    const { t } = useTranslation("common");

    return (
        <Modal 
            open={active}
            onClose={closeModal}
            title={
                <span className="reuse-dialog-title">
                    {t("reuseDocuments.submitHeader")}
                </span>
            }
        >
            <Modal.Section>
                <div className="reuse-dialog-content">
                    <p>{t("reuseDocuments.submitBody_1", { count: documentCountFunction() })}</p>
                    <br />
                    <p>{t("reuseDocuments.submitBody_2")}</p>
                </div>
                <div className="reuse-dialog-footer">
                    <Button submit size="large" onClick={closeModal}>{t("reuseDocuments.cancel")}</Button>
                    <Button primary size="large" onClick={submitDocuments}>{t("reuseDocuments.confirmReuse")}</Button>
                </div>
            </Modal.Section>
        </Modal>
    )
}